<!-- 维护节信息 -->
<template>
    <el-dialog :title="isedit ? '编辑下属节信息' : '新增下属节信息'" :visible.sync="dialogVisible" :before-close="handleClose" custom-class="dialogForm" class="measDialog maintainTask" width="670px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
        <el-scrollbar class="dialogContentScroll" v-loading="contentLoading">
            <el-form :model="params" :rules="rules" ref="maintainTask">
                <el-form-item label="节名称" prop="taskname">
                    <el-input v-model="params.taskname" placeholder="请输入节名称" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="内容类型" prop="kmctype">
                    <el-radio-group v-model="params.kmctype" @change="kmctypeChange">
                        <el-radio :label="4">视频</el-radio>
                        <el-radio :label="6">音频</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上传内容" prop="filekeyurl">
                    <div class="fileBox">
                        <div class="uploadBtnBox">
                            <el-button type="hollowOut" @click="choiceExistingContent" v-if="params.kmctype === 4" class="choiceExistingBtn">选择已有内容</el-button>
                            <UploadFile v-if="dialogVisible" ref="uploadFile1" :accept="params.kmctype === 4 ? '.mp4' : '.mp3'" :show-file-list="false" :scopeType="106" :fileMaxSize="102400" @success="fileUploadSuccess">
                                <el-button type="hollowOut">上传本地内容</el-button>
                            </UploadFile>
                        </div>
                        <div class="uploadFileMsg" v-if="params.filekeyurl">
                            <div class="fname">{{fname}}</div>
                            <i class="el-icon-close" @click="handleDeleteFile"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel" :disabled="loading" @click="handleClose">取消</el-button>
            <el-button type="primary" @click="saveCourseSectionTask" :loading="loading">保存</el-button>
        </span>
        <ChoiceVideoImage @saveMaterialFile="choiceExistingSuccess" :uploadType="uploadType" ref="choiceVideoImage" />
    </el-dialog>
</template>

<script>
import {saveCourseSectionTask, getCourseSectionTaskDetails} from '@/api/measApi/courseManage.js'
import ChoiceVideoImage from '@/components/measComponents/choiceVideoImage/choiceVideoImage.vue'
import UploadFile from '@/components/measComponents/uploadFile/uploadFile.vue'
export default {
    data() {
        return {
            dialogVisible: false,
            contentLoading: false,
            loading: false,
            isedit: false,
            params: {
                code: '', // 目标code
                filekeyid: '', // 文件KeyID
                filekeyurl: '', // 文件KeyUrl
                fileuploadtype: '', // 文件上传模式:1选择已有内容 2自定义上传
                kmctype: 4, // 内容来源类型-内容类型：只取4视频、6音频、2报告，报告以图片形式展示
                kmctypename: '视频', // 
                sectioncode: '', // 章code
                taskname: '', // 节名称
                vsource: '', // 选择已有内容:1对应资源 2素材库 3直接编写
                vsourcename: '',
                taskindex: '',
                fileduration: ''
            },
            fname: '',
            rules: {
                taskname: [
                    {required: true, message: '请输入节名称', trigger: ['change', 'blur']}
                ],
                kmctype: [
                    {required: true, message: '请选择内容类型', trigger: ['change', 'blur']}
                ],
                filekeyurl: [
                    {required: true, message: '请选择上传内容', trigger: ['change', 'blur']}
                ]
            },
            uploadType: {
                catecode: '106',
                datatype: 'VIDEO'
            },
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(sectioncode, code, taskindex) {
            this.dialogVisible = true
            this.params.sectioncode = sectioncode
            if (taskindex) {
                this.params.taskindex = taskindex
            }
            if (code) {
                this.isedit = true
                this.params.code = code
                this.getCourseSectionTaskDetails()
            } else {
                this.isedit = false
            }
            this.$nextTick(() => {
                this.$refs.maintainTask.clearValidate()
            })
        },
        handleClose() {
            if (this.loading) {
                this.$message.warning('提交数据中，请稍等')
                return
            }
            this.dialogVisible = false
            this.isedit = false
            this.params.code = ''
            this.params.filekeyid = ''
            this.params.filekeyurl = ''
            this.params.fileuploadtype = ''
            this.params.kmctype = 4
            this.params.kmctypename = '视频'
            this.params.sectioncode = ''
            this.params.taskname = ''
            this.params.vsource = ''
            this.params.vsourcename = ''
            this.params.taskindex = ''
        },
        kmctypeChange(value) {
            if(value === 4) {
                this.params.kmctypename = '视频'
            } else {
                this.params.kmctypename = '音频'
            }
            this.handleDeleteFile()
        },
        choiceExistingContent() {
            this.$refs.choiceVideoImage.openDialog()
        },
        choiceExistingSuccess(file) {
            this.params.fileduration = file.duration
            this.params.filekeyurl = file.furl
            this.params.filekeyid = file.key
            this.params.vsource = 2
            this.params.vsourcename = '素材库'
            this.fname = file.fname
            this.params.fileuploadtype = 1
        },
        fileUploadSuccess(file) {
            this.params.fileduration = Math.floor(file.duration)
            this.params.filekeyurl = file.atturl
            this.params.filekeyid = file.key
            this.params.vsource = 3
            this.params.vsourcename = '直接编写'
            this.fname = file.fname
            this.params.fileuploadtype = 2
        },
        handleDeleteFile() {
            this.params.filekeyurl = ''
            this.params.filekeyid = ''
            this.fname = ''
            this.params.vsource = ''
            this.params.vsourcename = ''
            this.params.fileuploadtype = ''
        },
        saveCourseSectionTask() {
            this.$refs.maintainTask.validate((valid) => {
                if (valid) {
                    this.loading = true
                    saveCourseSectionTask(this.params).then(res => {
                        this.loading = false
                        if (res.code === '000') {
                            this.$message.success(res.msg)
                            this.$emit('maintainTaskSuccess')
                            this.handleClose()
                        }
                    })
                } else {
                    this.$message.warning('请完善您的数据')
                }
            })
        },
        getCourseSectionTaskDetails() {
            this.contentLoading = true
            getCourseSectionTaskDetails({code: this.params.code}).then(res => {
                this.contentLoading = false
                if (res.code === '000') {
                    this.params.code = res.data.code
                    this.params.filekeyid = res.data.filekeyid
                    this.params.filekeyurl = res.data.filekeyurl
                    this.params.fileuploadtype = res.data.fileuploadtype
                    this.params.kmctype = res.data.kmctype
                    this.params.kmctypename = res.data.kmctypename
                    this.params.sectioncode = res.data.sectioncode
                    this.params.taskname = res.data.taskname
                    this.params.vsource = res.data.vsource
                    this.params.vsourcename = res.data.vsourcename
                    this.fname = res.data.filekeyurl.split('/')[res.data.filekeyurl.split('/').length - 1]
                }
            })
        }
    },
    components: {
        ChoiceVideoImage,
        UploadFile
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .maintainTask {
        .el-dialog.dialogForm {
            height: 432px;
            top: calc((100% - 432px) / 2) !important;
            .el-dialog__body {
                .el-form {
                    .el-form-item {
                        .el-form-item__content {
                            .fileBox {
                                .uploadBtnBox {
                                    margin-bottom: 14px;
                                    display: flex;
                                    align-items: center;
                                    .choiceExistingBtn {
                                        margin-right: 20px;
                                    }
                                }
                                .uploadFileMsg {
                                    height: 36px;
                                    background: #F6F7FB;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 0 16px;
                                    line-height: 36px;
                                    .fname {
                                        flex: 1;
                                        width: 0;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    .el-icon-close {
                                        font-size: 16px;
                                        color: #999999;
                                        line-height: 16px;
                                        height: 16px;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>